module.exports = __webpack_public_path__ + "static/media/results-page-goal-icon.728d21eb.svg";